"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "wrapEvents", {
  enumerable: true,
  get: function () {
    return _wrapEvents.wrapEvents;
  }
});
Object.defineProperty(exports, "wrapFetch", {
  enumerable: true,
  get: function () {
    return _wrapFetch.wrapFetch;
  }
});
Object.defineProperty(exports, "wrapHistory", {
  enumerable: true,
  get: function () {
    return _wrapHistory.wrapHistory;
  }
});
Object.defineProperty(exports, "wrapJsonP", {
  enumerable: true,
  get: function () {
    return _wrapJsonp.wrapJsonP;
  }
});
Object.defineProperty(exports, "wrapMutation", {
  enumerable: true,
  get: function () {
    return _wrapMutation.wrapMutation;
  }
});
Object.defineProperty(exports, "wrapPromise", {
  enumerable: true,
  get: function () {
    return _wrapPromise.wrapPromise;
  }
});
Object.defineProperty(exports, "wrapTimer", {
  enumerable: true,
  get: function () {
    return _wrapTimer.wrapTimer;
  }
});
Object.defineProperty(exports, "wrapXhr", {
  enumerable: true,
  get: function () {
    return _wrapXhr.wrapXhr;
  }
});
var _wrapEvents = require("./wrap-events");
var _wrapFetch = require("./wrap-fetch");
var _wrapHistory = require("./wrap-history");
var _wrapJsonp = require("./wrap-jsonp");
var _wrapMutation = require("./wrap-mutation");
var _wrapPromise = require("./wrap-promise");
var _wrapTimer = require("./wrap-timer");
var _wrapXhr = require("./wrap-xhr");